module.exports = __webpack_public_path__ + "static/media/detective.e3ba17ac.mp3";